import {
  UPDATE_TAGS_REQUEST,
  UPDATE_TAGS_SUCCESS,
  UPDATE_TAGS_FAILURE,
  CLEAR_TAGS } from '../constants'

import Api from '../services/api.js'
import history from '../history'

export function updateTagsRequest(){
  return {
    type: UPDATE_TAGS_REQUEST,
  }
}

export function updateTagsSuccess(body){
  return {
    type: UPDATE_TAGS_SUCCESS,
    body: body
  }
}

export function updateTagsFailure(exception){
  return {
    type: UPDATE_TAGS_FAILURE,
    exception: exception
  }
}

export function clearTags(){
  return {
    type: CLEAR_TAGS
  }
}

export function updateTags(plan_id, risk_id, control_id, tag_list) {
  let params = {
    risk_id: risk_id,
    control_id: control_id,
    tag_list: tag_list
  }
  return dispatch => {
    dispatch(updateTagsRequest())
    const api = new Api();
    return api.put("/api/v1/plan/"+ plan_id + "/update_tags", params)
    .then(response => {
      dispatch(updateTagsSuccess(response.data))
    })
    .catch(err => dispatch(updateTagsFailure(err)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/tags.js